import axios from 'axios';
import { Observable } from "rxjs/Observable";
// import 'rxjs/add/operator/switchMap';

import { toFromDates, toFromDispatchDates } from '../components/Common/cleanDates';

import {
  REQUEST_SALES_ORDERS_BY_FILTER,
  FETCH_SALES_ORDERS_SUCCESS,
  FETCH_SALES_ORDERS_FAILURE,
} from './type';

import {
  SALES_ORDERS_URL,
  MOBILE_SALES_ORDERS_URL,
  MOBILE_SALES_ORDERS_URL_v2,
} from './url';


import { ROOT_URL, ROOT_API_URL } from './root_url';
const isDSQ = ROOT_API_URL === 'https://dsq-scm.truckxi.com/api/' || ROOT_URL === 'https://dsq-scm.truckxi.com/api/';
const isWIZ = ROOT_API_URL === 'https://wiz-scm.truckxi.com/api/' || ROOT_URL === 'https://wiz-scm.truckxi.com/api/';
const isFJ = ROOT_API_URL === 'https://fj-scm.truckxi.com/api/' || ROOT_URL === 'https://fj-scm.truckxi.com/api/';
const isJTB = ROOT_API_URL === 'https://jtb-scm.truckxi.com/api/' || ROOT_URL === 'https://jtb-scm.truckxi.com/api/';
const isAFM =
  ROOT_API_URL === "https://afm-scm.truckxi.com/api/" ||
  ROOT_URL === "https://afm-scm.truckxi.com/api/" ||
  ROOT_API_URL === "https://afmstage-scm.truckxi.com/api/" ||
  ROOT_URL === "https://afmstage-scm.truckxi.com/api/";
const isABC =
  ROOT_API_URL === "https://abc-scm.truckxi.com/api/" ||
  ROOT_URL === "https://abc-scm.truckxi.com/api/";
const isKDW = ROOT_API_URL === 'https://kdw-scm.truckxi.com/api/' || ROOT_URL === 'https://kdw-scm.truckxi.com/api/';
const isABCFF = ROOT_API_URL === 'https://abcff-scm.truckxi.com/api/' || ROOT_URL === 'https://abcff-scm.truckxi.com/api/';
const isYI = ROOT_API_URL === 'https://ying-scm.truckxi.com/api/' || ROOT_URL === 'https://ying-scm.truckxi.com/api/';
const isFBD = ROOT_API_URL === 'https://fbd-scm.truckxi.com/api/' || ROOT_URL === 'https://fbd-scm.truckxi.com/api/';
const isWUFS = ROOT_API_URL === 'https://wufs-scm.truckxi.com/api/' || ROOT_URL === 'https://wufs-scm.truckxi.com/api/';
const isEcity = ROOT_API_URL === 'https://ct-scm.truckxi.com/api/' || ROOT_API_URL === 'https://ctstage-scm.truckxi.com/api/';

export function fetchSalesOrdersByFilter(postingDateGT, postingDateLT, days, status, user, productNum, route, dispatchDateGT, dispatchDateLT, dispatchDays, limit, page, searchFilter, warehouse) {
  let url = (route == 'salesOrders') ? SALES_ORDERS_URL : MOBILE_SALES_ORDERS_URL;
  const dates = toFromDates(days, postingDateGT, postingDateLT);
  const dispatchDates = toFromDispatchDates(dispatchDays, dispatchDateGT, dispatchDateLT)
  if (status == 'all') {
    status = '';
  } else {
    status = `&SaleStatus=${status}`;
  }

  if (user && user.value) {
    user = user.value;
  }
  if (user) {
    user = isEcity ? `&Deliver_Customer_id__Sales_User_id=${user}` : `&Sales_User_id=${user}`;
  } else {
    user = '';
  }

  if (warehouse && warehouse.value) {
    warehouse = warehouse.value;
  }
  if (warehouse) {
    warehouse = `&Pickup_Warehouse_id_id=${warehouse}`;
  } else {
    warehouse = '';
  }

  if (productNum) {
    productNum = `&ProductNum=${productNum}`;
  } else {
    productNum = '';
  }

  let belongWarehouse = ``;
  if ( isAFM ) {
    if (!localStorage.getItem('warehouseLocation') || localStorage.getItem('warehouseLocation') === '' || localStorage.getItem('warehouseLocation') === 'none') {
      belongWarehouse = ``;
    } else {
      belongWarehouse = `&BelongWarehouse=${localStorage.getItem('warehouseLocation')}`;
    }
  }

  let pageL = ``;
  let limitL = ``;
  let soNumL = ``;
  let companyL = ``;
  let fbaL = ``;
  let bolL = ``;
  let isaL = ``;
  let shippingL = ``;
  let containerL = ``;

  if ( isABC && route !== 'salesOrders') {
    url = (route == 'salesOrders') ? SALES_ORDERS_URL : MOBILE_SALES_ORDERS_URL_v2;
    if (page) {
      pageL = `&page=${page+1}`;
    } else {
      pageL = `&page=1`;
    }
    if (limit) {
      limitL = `&limit=${limit}`;
    } else {
      limitL = `&limit=99999`;
    }

    // if (searchFilter) {
      if (searchFilter.SONum) {
        soNumL = `&SONum=${searchFilter.SONum}`;
      }
      if (searchFilter.CompanyName) {
        companyL = `&CompanyName=${searchFilter.CompanyName}`;
      }
      if (searchFilter.FBACode) {
        fbaL = `&FBACode=${searchFilter.FBACode}`;
      }
      if (searchFilter.CustomerBOLNo) {
        bolL = `&BOLNum=${searchFilter.CustomerBOLNo}`;
      }
      if (searchFilter.IsaNo) {
        isaL = `&ISANum=${searchFilter.IsaNo}`;
      }
      if (searchFilter.ShippingStatus) {
        shippingL = `&ShippingStatus=${searchFilter.ShippingStatus}`;
      }
      if (searchFilter.ContainerNo) {
        containerL = `&ContainerNum=${searchFilter.ContainerNo}`;
      }
    // }

  }


  let IsOutbound = ``;
  if (isDSQ || isWUFS || isABCFF || isKDW || isYI || isFBD || isWIZ || isFJ || isJTB) {
    url = SALES_ORDERS_URL;
    if (route === 'salesOrders') {
      IsOutbound = `&IsOutbound=false`;
    } else if (route === 'outboundOrders') {
      IsOutbound = `&IsOutbound=true`;
    } else if (route === 'mobileSalesOrders') {
      // IsOutbound = `&IsOutbound=`;
      IsOutbound = ``;
      url = MOBILE_SALES_ORDERS_URL;
    }
  }

  return (dispatch) => {
    dispatch({
      type: REQUEST_SALES_ORDERS_BY_FILTER,
      payload: {
        url,
        dates,
        status,
        user,
        warehouse,
        productNum,
        dispatchDates,
        belongWarehouse,
        IsOutbound,
        pageL,
        limitL,
        soNumL,
        companyL,
        fbaL,
        bolL,
        isaL,
        shippingL,
        containerL,
      },
    });
  };
}

export const searchInvoicesByInvoiceNo = (searchType, searchTerm, pathname, limit, page) => (dispatch) => {

  let url = pathname === '/salesOrders' ? SALES_ORDERS_URL : MOBILE_SALES_ORDERS_URL;
  let params = {};
  
  if (searchType !== 'invoiceNo') {
    params[searchType] = searchTerm;
  } else {
    params['search'] = searchTerm;
  }
  
  if (!localStorage.getItem('warehouseLocation') || localStorage.getItem('warehouseLocation') === '') {
    // params['BelongWarehouse'] = ;
  } else {
    params['BelongWarehouse'] = localStorage.getItem('warehouseLocation');
  }


  if ( isABC && pathname !== '/salesOrders') {
    url = pathname === '/salesOrders' ? SALES_ORDERS_URL : MOBILE_SALES_ORDERS_URL_v2;
    if (page) {
      params['page'] = page+1;
    } else {
      params['page'] = 1;
    }
    if (limit) {
      params['limit'] = limit;
    } else {
      params['limit'] = 99999;
    }
  }

  axios.get(`${url}search/`, {
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    params: params,
  })
    .then((res) => {
      dispatch({
        type: FETCH_SALES_ORDERS_SUCCESS, payload: res,
      });
    })
    .catch((err) => {
      dispatch({
        type: FETCH_SALES_ORDERS_FAILURE,
        payload: JSON.stringify(err),
      });
    });
};

export const setOrdersToOpen = (SalesOrderids, success, failed) => dispatch => {
  axios({
    method: 'PUT',
    url: `${SALES_ORDERS_URL}open/`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    data: {
      ids: SalesOrderids.split(','),
    },
  })
    .then(res => {
      success();
    })
    .catch(err => {
      failed();
    })
}

export const uploadSOImage = (formData, success, failed) => dispatch => {
  console.log('uploadSOImage run');
  return;
  axios({
    method: 'POST',
    // url: `${SALES_ORDERS_URL}open/`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    data: formData,
  })
    .then(res => {
      success();
    })
    .catch(err => {
      failed();
    })
}

export const uploadSOPOD = (formData, success, failed) => dispatch => {
  console.log('uploadSOPOD run');
  return;
  axios({
    method: 'POST',
    // url: `${SALES_ORDERS_URL}open/`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    data: formData,
  })
    .then(res => {
      success();
    })
    .catch(err => {
      failed();
    })
}

export const searchInvoicesByTrackingNo = (searchTerm, pathname) => (dispatch) => {
  const url = pathname === '/salesOrders' ? SALES_ORDERS_URL : MOBILE_SALES_ORDERS_URL;
  let params = {};
  params['searchTrackingNo'] = searchTerm;
  if (!localStorage.getItem('warehouseLocation') || localStorage.getItem('warehouseLocation') === '') {
    // params['BelongWarehouse'] = ;
  } else {
    params['BelongWarehouse'] = localStorage.getItem('warehouseLocation');
  }
  axios.get(`${url}search/`, {
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    params: params,
  })
    .then((res) => {
      dispatch({
        type: FETCH_SALES_ORDERS_SUCCESS, payload: res,
      });
    })
    .catch((err) => {
      dispatch({
        type: FETCH_SALES_ORDERS_FAILURE,
        payload: JSON.stringify(err),
      });
    });
};

export const SalesOrderListEpic = action$ =>
  action$.ofType(REQUEST_SALES_ORDERS_BY_FILTER)
    .switchMap(action =>
      axios.get(
        `${action.payload.url}search/?OrderDate__gte=${action.payload.dates.fromDate
        }&OrderDate__lte=${action.payload.dates.toDate}&DispatchDate__gte=${action.payload.dispatchDates.dispatchDateGT}&DispatchDate__lte=${action.payload.dispatchDates.dispatchDateLT}${action.payload.status}${action.payload.user}${action.payload.warehouse}${action.payload.productNum}${action.payload.belongWarehouse}${action.payload.IsOutbound}${action.payload.pageL ? action.payload.pageL : ''}${action.payload.limitL ? action.payload.limitL : ''}${action.payload.soNumL ? action.payload.soNumL : ''}${action.payload.companyL ? action.payload.companyL : ''}${action.payload.fbaL ? action.payload.fbaL : ''}${action.payload.containerL ? action.payload.containerL : ''}${action.payload.isaL ? action.payload.isaL : ''}${action.payload.shippingL ? action.payload.shippingL : ''}${action.payload.bolL ? action.payload.bolL : ''}`, //${action.payload.pageL}${action.payload.limitL}${action.payload.soNum}${action.payload.companyL}${action.payload.fbaL}
        {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        },
      ))
    .map(response => ({ type: FETCH_SALES_ORDERS_SUCCESS, payload: response }))
    .catch((err, source) => {
      return source;
      // return ActionsObservable.of({
      //   type: FETCH_SALES_ORDERS_FAILURE,
      //   payload: JSON.stringify(err),
      // })
    });



// WEBPACK FOOTER //
// ./master/jsx/actions/salesOrderList_actions.jsx